<template>
  <div style="padding: 15px">
    <el-checkbox v-model="multiple" label="是否多选" size="large" />
    <el-radio-group v-model="type" style="margin: 0 15px">
      <el-radio :label="'org'" size="large">全机构</el-radio>
      <el-radio :label="'corp'" size="large">单位</el-radio>
      <el-radio :label="'depart'" size="large">部门</el-radio>
    </el-radio-group>
    <el-button type="primary" @click="showDialog">点击</el-button>
    <LsSelectOrg
      :show.sync="visible"
      :type="type"
      :org="org"
      :multiple="multiple"
      @submit="submit"
      @close="closeDialog"
    ></LsSelectOrg>
  </div>
</template>

<script>
import LsSelectOrg from "./LsSelectOrg.vue";

export default {
  name: "SelectIndex",
  components: {
    LsSelectOrg,
  },
  data() {
    return {
      visible: false,
      type: "org",
      multiple: true,
      org: ["1293518290672460765"],
    };
  },
  watch: {},
  methods: {
    showDialog() {
      this.visible = true;
    },
    submit(data) {
      console.log(this.visible, data, "关闭弹窗");
      let temp = [];
      data.map((item) => {
        temp.push(item.id);
      });
      this.org = temp;
    },
    closeDialog() {
      console.log("关闭弹窗close");
    },
  },
};
</script>

<style lang="scss" scoped></style>
